export default __webpack_public_path__ + "static/how_it_work_5-c913637c6e9ae20fa2c6b3d25d94822b.png";